import React, { useCallback } from "react";
import useNaturalSort from "./useNaturalSort";
import { firstBy } from "thenby";

/**
 *
 * @deprecated
 * Name clash with useFilteredExercises from FilteredExercisesContext */
function useFilteredExercises(exercises, repExercisesOnly) {
  const naturalCompare = useNaturalSort();

  const filterNonRepExercises = useCallback(
    function filterNonRepExercises(exercise) {
      if (repExercisesOnly) {
        return !!exercise.repetitions?.length;
      }
      return true;
    },
    [repExercisesOnly]
  );

  const categories = React.useMemo(
    () =>
      exercises
        .filter(filterNonRepExercises)
        .reduce((uniqueCategories, currentExercise) => {
          if (!uniqueCategories.includes(currentExercise.category)) {
            return [...uniqueCategories, currentExercise.category];
          }

          return uniqueCategories;
        }, [])
        .sort(firstBy((v) => v, { cmp: naturalCompare })),
    [naturalCompare, exercises, filterNonRepExercises]
  );

  const categoryExercises = React.useCallback(
    (category) => {
      return exercises
        .filter(filterNonRepExercises)
        .filter((exercise) => exercise.category === category)
        .sort(firstBy("name", { cmp: naturalCompare }));
    },
    [naturalCompare, exercises, filterNonRepExercises]
  );

  const exerciseMetrics = React.useCallback(
    (exercise) => {
      if (!exercise) {
        return [];
      }

      const metrics = exercises
        .filter(filterNonRepExercises)
        .find((item) => item.id === exercise.id)
        ?.metrics?.sort(firstBy("name", { cmp: naturalCompare }));

      if (!metrics) {
        return [];
      }

      return metrics;
    },
    [naturalCompare, exercises, filterNonRepExercises]
  );

  const exerciseRepMetrics = React.useCallback(
    (exercise) => {
      if (!exercise) {
        return [];
      }

      const repMetrics = exercises
        .filter(filterNonRepExercises)
        .find((item) => item.id === exercise.id)
        ?.repetitions?.sort(firstBy("name", { cmp: naturalCompare }));

      if (!repMetrics) {
        return [];
      }

      return repMetrics;
    },
    [naturalCompare, exercises, filterNonRepExercises]
  );

  return {
    exercises: exercises.filter(filterNonRepExercises),
    categories,
    categoryExercises,
    exerciseMetrics,
    exerciseRepMetrics,
  };
}
export default useFilteredExercises;
